/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Properties_Bulk_Transfer_TitleInputs */

const cs_properties_bulk_transfer_title = /** @type {(inputs: Properties_Bulk_Transfer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Převod portfolia`)
};

const en_properties_bulk_transfer_title = /** @type {(inputs: Properties_Bulk_Transfer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transfer portfolio`)
};

/**
* | output |
* | --- |
* | "Transfer portfolio" |
*
* @param {Properties_Bulk_Transfer_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const properties_bulk_transfer_title = /** @type {((inputs?: Properties_Bulk_Transfer_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Properties_Bulk_Transfer_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_properties_bulk_transfer_title(inputs)
	return cs_properties_bulk_transfer_title(inputs)
});